import { render } from "./Audio.vue?vue&type=template&id=5711b796&scoped=true"
import script from "./Audio.vue?vue&type=script&lang=js"
export * from "./Audio.vue?vue&type=script&lang=js"

import "./Audio.vue?vue&type=style&index=0&id=5711b796&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5711b796"]])

export default __exports__